import React from "react";

import {
  Drawer,
  makeStyles,
  Close,
  IconButton,
} from "../../shared/materials/helper";

import ChallanBaseButton from "../../shared/materials/Buttons/ChallanBaseButton";

import AddUsersAlt from "../../../assests/icons/AddUsersAlt";
import ChallanPasswordInput from "../../shared/materials/Inputs/ChallanPasswordInput";
import Notifications from "../../../utils/notifications";

const useStyles = makeStyles((theme) => ({
  container: { width: "50%" },
  drawerContainer: {
    width: "35vw",
    padding: theme.spacing(4),
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
  },
  headerText: {
    fontWeight: 700,
    fontSize: 20,
  },
  subHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: theme.spacing(3),
  },
  subheaderText: {
    fontWeight: 600,
    fontSize: 16,
  },
  subheaderSubText: {
    fontWeight: 400,
    fontSize: 12,
    margin: 0,
  },
}));

export default function ChangePassword({ state, setState, onUpdate }) {
  const [password, setPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const classes = useStyles();

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState(open);
  };

  const onSubmitClick = async (event) => {
    if (password !== confirmPassword) {
      Notifications.error("Password doesn't match!");
      return;
    }

    const status = await onUpdate(password);

    if (status) {
      setPassword("");
      setConfirmPassword("");
      toggleDrawer(false)(event);
    }
  };

  const onPasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const onConfPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };

  return (
    <div className={classes.container}>
      <Drawer anchor={"right"} open={state} onClose={toggleDrawer(false)}>
        <div className={classes.drawerContainer}>
          <div className={classes.header}>
            <h1 className={classes.headerText}>Change Password</h1>
            <IconButton
              onClick={toggleDrawer(false)}
              sx={{ width: 48, height: 48 }}
            >
              <Close />
            </IconButton>
          </div>
          <div className={classes.subHeader}>
            <AddUsersAlt />
            <p className={classes.subheaderText}>Update user's password</p>
            {/* <p className={classes.subheaderSubText}>
              Update users as a viewer or an admin
            </p> */}
          </div>
          {/* <form onSubmit={onSubmitClick}> */}
          <ChallanPasswordInput
            id="password-change"
            label="Change Password"
            placeholder={"Change Password of the user..."}
            onChange={onPasswordChange}
            value={password}
            inputProps={{
              autoComplete: "new-password",
              form: {
                autoComplete: "off",
              },
            }}
          />
          <ChallanPasswordInput
            id="conf-password-create"
            label="Confirm Password"
            placeholder={"Confirm Password of the user..."}
            onChange={onConfPasswordChange}
            value={confirmPassword}
            inputProps={{
              autoComplete: "new-password-conf",
              form: {
                autoComplete: "off",
              },
            }}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              paddingBottom: 16,
              paddingTop: 16,
            }}
          >
            <ChallanBaseButton
              onClick={toggleDrawer(false)}
              text={"Cancel"}
              type={"cancel"}
              width={"48%"}
            />
            <ChallanBaseButton
              onClick={onSubmitClick}
              text={"Apply Change"}
              type={"ok"}
              width={"48%"}
              //typeOf={"submit"}
            />
          </div>
          {/* </form> */}
        </div>
      </Drawer>
    </div>
  );
}
